import * as React from 'react';
import clsx from 'clsx';
import type { SurveyQuestion, SingleChoiceAnswer } from '@/types/survey';

interface Props {
  question: SurveyQuestion;
  answer: SingleChoiceAnswer | undefined;
  onChange: (ans: SingleChoiceAnswer) => void;
}

export const SingleChoiceQuestion: React.FC<Props> = ({ question, answer, onChange }) => (
  <div className='flex flex-col gap-3'>
    {question.options?.map((opt) => {
      const isSelected = answer?.answer_id === opt.id;
      return (
        <button
          key={opt.id}
          type='button'
          onClick={() =>
            onChange({
              question_id: question.id,
              question_type: 'single_choice',
              answer_id: opt.id,
              answer_text: opt.text,
            })
          }
          className={clsx(
            'flex w-full items-center gap-4 rounded-12 p-4 text-left transition-all',
            'border',
            isSelected
              ? 'border-brand-300 bg-brand-50 shadow-sm'
              : 'border-gray-200 bg-white hover:bg-gray-50'
          )}
        >
          <div
            className={clsx(
              'flex size-5 shrink-0 items-center justify-center rounded-full border',
              isSelected ? 'border-brand-600' : 'border-gray-400'
            )}
          >
            {isSelected && <div className='size-2.5 rounded-full bg-brand-600' />}
          </div>

          <div className='flex flex-1 items-center gap-3'>
            {opt.icon && <span className='text-xl'>{opt.icon}</span>}
            <span
              className={clsx(
                'font-sans text-16 leading-[1.4]',
                isSelected ? 'font-medium text-brand-900' : 'font-normal text-gray-700'
              )}
            >
              {opt.text}
            </span>
          </div>
        </button>
      );
    })}
  </div>
);

export default SingleChoiceQuestion;
